import {
  AuthModeEnum,
  type ChainEnum,
  type ConnectRequest,
} from '@dynamic-labs/sdk-api-core';

import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import { createApiClient } from '../../apiClient';
import { getWalletProviderFromWalletAccount } from '../../wallets/utils/getWalletProviderFromWalletAccount';
import { normalizeWalletNameWithChain } from '../../wallets/utils/normalizeWalletNameWithChain';
import type { WalletAccount } from '../../wallets/walletAccount';

type CreateVisitParams = {
  authMode?: AuthModeEnum;
  walletAccount: WalletAccount;
};

/*  
  In older SDK versions we used to have the concept of "connect-only" vs "connect-and-sign". 
  The only difference in backend is it stores some extra data for connect-only, 
  so we can just default to using it.
*/
export const createVisit = async (
  { walletAccount, authMode = AuthModeEnum.Only }: CreateVisitParams,
  client: DynamicClient
) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const walletProvider = getWalletProviderFromWalletAccount(
    { walletAccount },
    client
  );

  try {
    const walletName = normalizeWalletNameWithChain({
      chain: walletProvider.chain,
      displayName: walletProvider.metadata.displayName,
    });

    const connectRequest: ConnectRequest = {
      address: walletAccount.address,
      authMode,
      // eslint-disable-next-line custom-rules/ban-chain-enum
      chain: walletProvider.chain as ChainEnum,
      provider: walletProvider.walletProviderType,
      walletName,
    };

    await apiClient.createVisit({
      connectRequest,
      environmentId: core.environmentId,
    });
  } catch (error) {
    core.logger.error('Error creating visit', { error });
  }
};
